var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lockPoster)?_c('div',{staticClass:"posterImg"},[_c('div',[_c('img',{attrs:{"src":_vm.mobilePosterImg,"alt":""}}),_c('p',{staticClass:"posterDown"},[_vm._v(_vm._s(_vm.mobileTip))])]),_c('div',{staticClass:"close",on:{"touchend":_vm.closePoster}},[_vm._v("×")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }